import type { ModelBranchLite } from '@app/api/Branches/types';
import type { WithActiveBranchId } from '@app/api/shared';

export enum ChainsEndpoints {
  UpdateChain = 'UpdateChain',
  GetChains = 'GetChains',
  GetChainsForSystem = 'GetChainsForSystem',
  GetChain = 'GetChain',
}

export interface ModelItem {
  Id: number;
  IdS: string | null;
  Name: string | null;
}

export interface ModelChain {
  Id: number;
  Name: string | null;
  CountBranches: number;
  IsDeleted: boolean;
  MigrateId?: number | null;
  ChainBranches: ModelBranchLite[] | null;
}

export type UpdateChainBranch = Pick<
  ModelBranchLite,
  'BranchId' | 'Name' | 'IsSelected'
>;

export interface UpdateChainPayload {
  Id: number;
  Name: string | null;
  CountBranches: number;
  IsDeleted: boolean;
  ChainBranches: UpdateChainBranch[];
  MigrateId?: number | null;
}

export interface ModelChainsList {
  Chains: ModelChain[] | null;
  CountActive: number;
  CountDeleted: number;
}

export type UpdateChainRequest = WithActiveBranchId<{
  data: UpdateChainPayload;
}>;

export type GetChainsRequest = WithActiveBranchId<{
  isActive?: boolean;
  isDeleted?: boolean;
}>;

export type GetChainsForSystemRequest = WithActiveBranchId;

export type GetChainRequest = WithActiveBranchId<{
  chainId: number;
}>;

export type UpdateChainResponse = ModelChain;
export type GetChainsResponse = ModelChainsList;
export type GetChainsForSystemResponse = ModelItem[];
export type GetChainResponse = ModelChain;
